export enum FundingStructureEnum {
  EQUITY_FIRST = 'EquityFirst',
  PARI_PASSU = 'PariPassu',
  HYBRID = 'Hybrid',
}
